import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { ArrowLeft, ShieldCheck } from 'lucide-react';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ backgroundColor: 'var(--bg-color)', minHeight: '100vh', color: 'var(--text-primary)', padding: '2rem 1rem' }}>
      <SEO title="Politique de Confidentialité | Masse-terclass" />
      <div style={{ maxWidth: '800px', margin: '0 auto', backgroundColor: 'var(--bg-card)', padding: '2rem', borderRadius: '12px', border: '1px solid var(--border-color)' }}>
        
        <button className="btn btn-outline" onClick={() => { window.scrollTo(0,0); navigate('/'); }} style={{ marginBottom: '2rem', display: 'inline-flex', alignItems: 'center', gap: '0.5rem' }}>
          <ArrowLeft size={18} /> Retour
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
          <ShieldCheck size={40} color="var(--primary-color)" />
          <h1 style={{ color: 'var(--primary-color)', margin: 0, fontSize: '2.2rem' }}>Politique de Confidentialité</h1>
        </div>
        
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>1. Données collectées</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Dans le cadre de l'utilisation de Masse-terclass, nous sommes amenés à collecter certaines de vos données personnelles :
          </p>
          <ul style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginLeft: '1.5rem', marginTop: '0.5rem' }}>
            <li><strong>Données d'identification :</strong> Nom, prénom, et adresse e-mail lors de la création de votre compte.</li>
            <li><strong>Données d'entraînement :</strong> Poids, mensurations, historique de vos séances et de vos performances.</li>
            <li><strong>Données sociales :</strong> Vos publications sur le forum, votre liste d'amis, et vos scores sur le classement.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>2. Finalité de la collecte</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Vos données sont collectées dans le but exclusif de vous fournir les services de l'application Masse-terclass :
          </p>
          <ul style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginLeft: '1.5rem', marginTop: '0.5rem' }}>
            <li>Créer et sécuriser votre compte utilisateur.</li>
            <li>Suivre votre progression sportive et vous fournir des statistiques.</li>
            <li>Permettre les interactions sociales avec d'autres utilisateurs (si vous choisissez de rendre votre profil public).</li>
            <li>Personnaliser l'intelligence artificielle (Coach IA) selon votre profil.</li>
          </ul>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginTop: '0.5rem' }}>
            <strong>Aucune donnée personnelle n'est revendue ou cédée à des tiers à des fins commerciales ou publicitaires.</strong>
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>3. Stockage et Sécurité</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            L'ensemble de vos données sont hébergées de manière sécurisée sur les serveurs européens de <strong>Google Firebase</strong> (Firebase Authentication pour la gestion des accès, et Firestore pour la base de données). Firebase applique des normes de sécurité strictes pour chiffrer et protéger vos données.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>4. Vos droits (RGPD)</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants concernant vos données personnelles :
          </p>
          <ul style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginLeft: '1.5rem', marginTop: '0.5rem' }}>
            <li><strong>Droit d'accès et de rectification :</strong> Vous pouvez modifier vos informations à tout moment depuis les paramètres de votre compte.</li>
            <li><strong>Droit à l'effacement :</strong> Vous pouvez supprimer votre compte et toutes vos données associées à tout moment depuis les paramètres.</li>
            <li><strong>Droit à la portabilité :</strong> Vous pouvez demander un export de vos données d'entraînement.</li>
          </ul>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)', marginTop: '0.5rem' }}>
            Pour toute demande d'exercice de ces droits, ou pour toute question concernant cette politique, vous pouvez nous contacter via la page <Link to="/contact" style={{ color: 'var(--primary-color)' }}>Contact</Link> ou à l'adresse <strong>contact@masse-terclass.com</strong>.
          </p>
        </section>
        
        <section>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary)' }}>5. Cookies</h2>
          <p style={{ lineHeight: '1.6', color: 'var(--text-secondary)' }}>
            Nous utilisons uniquement des cookies strictement nécessaires au fonctionnement technique de l'application (comme le maintien de votre session de connexion sécurisée et la mémorisation du thème sombre/clair). Aucun outil de traçage ou de mesure d'audience externe n'est utilisé.
          </p>
        </section>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
